import {BaseCommand} from './base.command';
import {OverlayElementResizeSnapshot} from '../interfaces/command.interface';
import {OverlayElementApiService} from '../../../api/services/overlay-element.service';
import {OverlayElementManagerService} from '../../overlay-element-manager.service';
import {catchError, firstValueFrom, of} from 'rxjs';

export class ResizeOverlayElementCommand extends BaseCommand<OverlayElementResizeSnapshot> {
  constructor(
    private overlayService: OverlayElementApiService,
    private overlayManager: OverlayElementManagerService,
    snapshot: OverlayElementResizeSnapshot
  ) {
    super(
      'resize-overlay-element',
      'Overlay Size Change',
      {
        before: snapshot,
        after: snapshot
      },
      {object: 'Overlay', verb: 'Change', part: 'Size'}
    );
  }

  async execute(): Promise<void> {
    const {elementId, after} = this.snapshot.after;
    const element = this.overlayManager.getElements().find(e => e.id === elementId);
    if (element) {
      element.width = after.width;
      element.height = after.height;
      element.rotation = after.rotation;
      element.x = after.x;
      element.y = after.y;
      this.overlayManager.updateElement(element);
    }

    await firstValueFrom(
      this.overlayService.update({
        id: elementId,
        width: after.width,
        height: after.height,
        rotation: after.rotation,
        x: after.x,
        y: after.y
      }).pipe(catchError(() => of(null)))
    );
  }

  async undo(): Promise<void> {
    const {elementId, before} = this.snapshot.before;
    const element = this.overlayManager.getElements().find(e => e.id === elementId);
    if (element) {
      element.width = before.width;
      element.height = before.height;
      element.rotation = before.rotation;
      element.x = before.x;
      element.y = before.y;
      this.overlayManager.updateElement(element);
    }

    await firstValueFrom(
      this.overlayService.update({
        id: elementId,
        width: before.width,
        height: before.height,
        rotation: before.rotation,
        x: before.x,
        y: before.y
      }).pipe(catchError(() => of(null)))
    );
  }
}
